import { render, staticRenderFns } from "./CategoryLayout.vue?vue&type=template&id=0b50416d"
import script from "./CategoryLayout.vue?vue&type=script&lang=js"
export * from "./CategoryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports